import { create } from "zustand"

type ExportVersionDialogState = {
  isOpen: boolean
}

type ExportVersionDialogActions = {
  onOpen: () => void
  onClose: () => void
}

const useExportVersionDialogV1 = create<
  ExportVersionDialogState & ExportVersionDialogActions
>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}))

export default useExportVersionDialogV1
